import type { FaireProductEntity } from "../../entity_types/product";

export const p_mxqpsethe7: FaireProductEntity = {
  token: "p_mxqpsethe7",
  type: "product",
  name: " Macarons Faux Leather Mini Purse Keychain Bag Charm",
  brandName: "Sparkling Extras",
  imageUrl:
    "https://cdn.faire.com/fastly/6ada78cdef599af164823ebe91324103aa36e7eb8264ee665f46bb2db03c8029.jpeg",
  priceDollars: 7.59,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7a2b5dc9a3f5d5810e2c807ae2423ee9bf8aca3bfae6694d87dc718c9a3dd9c9.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
